import { Controller } from "@hotwired/stimulus"
import { uniq } from "../helpers"

export default class extends Controller {
  static targets = ["form", "count", "button"]
  static values = {
    count: Number,
    label: String,
    labelPlural: String,
  }

  initialize() {
    this.updateCount()
    this.updateButton()
  }

  updateButton() {
    if (this.count > 0) {
      this.buttonTarget.classList.add("text-accent", "bg-accent-tint")
    } else {
      this.buttonTarget.classList.remove("text-accent", "bg-accent-tint")
    }
    this.buttonTarget.title = this.getCountText()
  }

  updateCount() {
    this.countValue = this.count
    this.countTarget.textContent = this.getCountText()
  }

  getCountText() {
    if (this.countValue > 0) {
      return `${this.countValue} ${this.countValue === 1 ? this.labelValue : this.labelPluralValue}`
    } else {
      return this.labelValue
    }
  }

  get count() {
    return this.uniqueValues.length
  }

  get formKeys() {
    const formData = new FormData(this.formTarget)
    return Array.from(formData.entries())
      .filter(([key, value]) => {
        const element = this.formTarget.querySelector(`[name="${key}"]`)
        return element.type !== "hidden" && value.trim() !== ""
      })
      .map(([key]) => key)
  }

  get uniqueValues() {
    return uniq(this.formKeys)
  }
}
